import { Box, Text } from "@chakra-ui/react";
import { RECAPTCHA_SITE_KEY } from "infra/config";
import { useEffect, useRef, useState } from "react";

declare global {
  interface Window {
    grecaptcha?: {
      ready?: (callback: () => void) => void;
      render: (container: HTMLElement, options: { sitekey: string; callback: (token: string) => void; "expired-callback": () => void }) => number;
    };
  }
}

export default function Recaptcha({ onChange }: { onChange: (token: string) => void }) {
  const container = useRef<HTMLDivElement>(null);
  const widgetId = useRef<number>();
  const [error, setError] = useState(false);

  useEffect(() => {
    const render = () => {
      if (!container.current || widgetId.current !== undefined || !window.grecaptcha) return;
      const renderWidget = () => {
        if (!container.current || widgetId.current !== undefined || !window.grecaptcha) return;
        try {
          widgetId.current = window.grecaptcha.render(container.current, {
            sitekey: RECAPTCHA_SITE_KEY,
            callback: onChange,
            "expired-callback": () => onChange(""),
          });
        } catch {
          setError(true);
        }
      };
      if (window.grecaptcha.ready) {
        window.grecaptcha.ready(renderWidget);
      } else {
        renderWidget();
      }
    };

    const existing = document.querySelector<HTMLScriptElement>('script[src*="google.com/recaptcha/api.js"]');
    if (existing) {
      existing.addEventListener("load", render);
      render();
      return () => existing.removeEventListener("load", render);
    }

    const script = document.createElement("script");
    script.src = "https://www.google.com/recaptcha/api.js?render=explicit&hl=pt-BR";
    script.async = true;
    script.defer = true;
    script.addEventListener("load", render);
    script.addEventListener("error", () => setError(true));
    document.head.appendChild(script);
    return () => script.removeEventListener("load", render);
  }, [onChange]);

  if (error) return <Text color="red.500">Não foi possível carregar o CAPTCHA. Verifique o domínio da chave.</Text>;
  return <Box ref={container} aria-label="Verificacao de seguranca" minH="78px" />;
}
